export default function Ellipsis() {
  const ellipsis = "\u2026";
  return <span className="text-cp-grey-600 cursor-default">{ellipsis}</span>;
}
